import React from 'react';
import dynamic from 'next/dynamic';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';

// dynamic imports
const DateBlock = dynamic(() => import('../ProductionDateBlock'));

const useStyles = makeStyles(() => ({
  monthBlock: {
    margin: 2,
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

const ProductionDatesContent = ({ className, formattedDates, cancelled }) => {
  const classes = useStyles();

  return (
    <Grid item className={classNames(classes.root, className)}>
      {formattedDates && (
        <>
          {Object.keys(formattedDates).map((key, index) => (
            <DateBlock
              key={`${key}-${index}`}
              title={key}
              dates={get(formattedDates, key, [])}
              className={classes.monthBlock}
              isCancelled={cancelled}
            />
          ))}
        </>
      )}
    </Grid>
  );
};

ProductionDatesContent.propTypes = {
  formattedDates: PropTypes.object,
  className: PropTypes.string,
};

export default ProductionDatesContent;
